import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import { take } from 'ramda'
import withNotifications from 'components/shared/notifications'
import { getHubspotToggles, patchHubspotToggles } from 'app/modules/integrations/api'
import IntegrationToggles from 'components/IntegrationToggles'
import { model, hydrateModel } from './model'
import { Icon } from '@driftt/tide-core-legacy'

const CONNECT_ERROR_MESSAGE = 'We could not fetch your settings.'
const PATCH_ERROR_MESSAGE = 'We could not save your changes.'

class HubspotConfig extends Component{

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  state = {
    toggles: model
  }

  componentDidMount() {
    getHubspotToggles()
      .then(this.receiveToggles)
      .catch(this.onError)
  }

  onError = () => {
    const { router } = this.context

    this.props.notifications.error(CONNECT_ERROR_MESSAGE)
    router.push({ pathname: '/settings/setup/hubspot' })
  }

  onPatchError = () => {
    this.props.notifications.error(PATCH_ERROR_MESSAGE)
  }

  receiveToggles = resp => {
    this.setState({
      toggles: hydrateModel(resp)
    })
  }

  settingsUpdatedNotification = () => this.props.notifications.success('HubSpot settings are updated!')

  patchToggle = (event, toggle) => {
    const data = { [toggle.type]: event }

    patchHubspotToggles(data)
      .then(this.receiveToggles)
      .then(this.settingsUpdatedNotification)
      .catch(this.onPatchError)
  }

  render(){
    const { toggles } = this.state
    const numToggles = toggles.length

    return (
      <div className="common-integration-page-layout "> 
        <IntegrationBreadcrumb
          backLinkText="Hubspot Integration"
          backLinkUrl="/settings/setup/hubspot"
        />        
        <header>
          <h2 className="integration-header">Synced Hubspot Data</h2>
          <p>Choose which data is sent between Hubspot and Drift.</p>
        </header>

        <h3 className="integration-header">
          Drift
          <Icon
            className="right-arrow"
            width={15}
            height={10}
            name="arrow-2-right"
          />
          Hubspot
        </h3>
        <IntegrationToggles
          toggles={take(numToggles - 2, toggles)}
          onChange={this.patchToggle}
        />

        {toggles[0].value === true && <IntegrationToggles
          toggles={[toggles[numToggles - 2]]}
          onChange={this.patchToggle}
        />}

        <h3 className="integration-header">
          Hubspot
          <Icon
            className="right-arrow"
            width={15}
            height={10}
            name="arrow-2-right"
          />
          Drift
        </h3>
        <IntegrationToggles
          toggles={[toggles[numToggles - 1]]}
          onChange={this.patchToggle}
        />
      </div>
    )
  }
}

export default withNotifications(HubspotConfig)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/HubspotConfig/index.js